import React from 'react'
import styled from 'styled-components'

import KeyboardAccessible from 'components/KeyboardAccessible'
import Tooltip from 'components/Tooltip'

import AlertIcon from 'pages/shared/Alert/Icon'
import { color } from 'styles/colors'

type Props = {
  severity: string
  count: number | null
  className?: string
}

const AlertIconWithCount = ({ severity, count, className } : Props) => (
  <div className={className}>
    { (count ?? 0) > 0 &&
      <Tooltip title={`Total number of ${severity} alerts.`} placement="top" >
        <S.Container readOnly>
          <span>
            <S.AlertIcon
              severity={severity}
              size="14px"
            />
          </span>
          <S.Count severity={severity}>
            {count}
          </S.Count>
        </S.Container>
      </Tooltip>
    }
  </div>
)

export default AlertIconWithCount

const S = {
  AlertIcon: styled(AlertIcon)`
    font-size: ${({ size }) => size};
  `,

  Count: styled.span.withConfig({
    shouldForwardProp: (prop) => !['severity'].includes(prop)
  })<{ severity: string }>`
    vertical-align: sub;
    margin-left: 4px;
    margin-right: 5px;
    ${({ severity }) => `color: ${color(severity.replace('-s', 'S') + 'Alert')}`}
  `,
  Container: styled(KeyboardAccessible)`
    margin-left: 5px;
    padding-left: 5px;
  `
}
